export enum ParticipantType {
  User = 'User',
  System = 'System',
  Guest = 'Guest',
  AI = 'AI'
}
